import PhaseSixIcon from "../phaseSixIcon/PhaseSixIcon";
import useBreakpoints, { Breakpoint } from "../../hooks/useBreakpoints";
import DesignConstants from "../../constants/DesignConstants";

interface CreateOptionCardImage {
    src: string;
    alt: string;
}

export interface CreateOptionCardData {
    "data-testid"?: string;
    title: string;
    subtitle: string;
    onClick: () => void;
    image: CreateOptionCardImage;
    borderColor: string;
    titleColor: string;
}

interface CreateOptionCardProps {
    option: CreateOptionCardData;
    showChevron: boolean;
}

const CreateOptionCard = (props: CreateOptionCardProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    return (
        <div className="flex flex-row items-stretch">
            <button
                data-testid={props.option["data-testid"]}
                type="button"
                onClick={props.option.onClick}
                className={`flex-1 w-full rounded-medium border-2 ${props.option.borderColor} flex flex-col gap-s overflow-hidden bg-white hover:brightness-95 cursor-pointer pb-m`}
            >
                <div
                    className={`w-full border-b ${props.option.borderColor} ${getStyleBasedOnBreakpoint(
                        Breakpoint.MD,
                        "h-[180px]",
                        "h-[150px]"
                    )}`}
                >
                    <img
                        src={props.option.image.src}
                        alt={props.option.image.alt}
                        className="h-full w-full object-cover"
                    />
                </div>
                <div className="px-m gap-xxs flex flex-col items-center">
                    <h3 className={`text-xxl leading-none text-center ${props.option.titleColor}`}>
                        {props.option.title}
                    </h3>
                    <p className="text-p6-grey-dark text-l text-center">{props.option.subtitle}</p>
                </div>
            </button>
            {props.showChevron && (
                <div
                    className={`self-center ${getStyleBasedOnBreakpoint(
                        Breakpoint.MD,
                        "flex items-center justify-center",
                        "hidden"
                    )}`}
                    style={{
                        width: DesignConstants.SIZES.ICON_L,
                        height: DesignConstants.SIZES.ICON_L,
                        fontSize: DesignConstants.SIZES.ICON_L,
                    }}
                >
                    <PhaseSixIcon
                        name="chevron-right"
                        color={DesignConstants.COLORS.MID_GREY}
                    />
                </div>
            )}
        </div>
    );
};

export default CreateOptionCard;
